import type { JSX } from 'react';
import { ButtonBase, styled } from '@mui/material';
import { corePalette } from '@/themes/colours';
import {
  POPUP_GLYPH_INDENT,
  POPUP_SAMPLE_CHILD_LIMIT,
} from '@/constants/PatientDashboard/patientTimeline';
import type { ITimelinePopupSampleGroup } from '@/types/PatientDashboard/PatientTimeline.types';
import TimelinePopupSampleRow from './TimelinePopupSampleRow';

const SHOW_MORE_LABEL = 'Show more';
const SHOW_LESS_LABEL = 'Show less';

const ToggleButton = styled(ButtonBase)({
  alignSelf: 'flex-start',
  marginLeft: POPUP_GLYPH_INDENT,
  padding: '2px 0',
  color: corePalette.green150,
  fontSize: '12px',
  lineHeight: '130%',
  fontWeight: 500,
  '&:hover': {
    textDecoration: 'underline',
  },
});

interface IProps {
  group: ITimelinePopupSampleGroup;
  isExpanded: boolean;
  onToggle: (groupId: string) => void;
}

export default function TimelinePopupSampleGroup({
  group,
  isExpanded,
  onToggle,
}: IProps): JSX.Element {
  const { parent, children } = group;
  const hiddenCount = children.length - POPUP_SAMPLE_CHILD_LIMIT;
  const visibleChildren = isExpanded ? children : children.slice(0, POPUP_SAMPLE_CHILD_LIMIT);

  const handleToggle = (): void => onToggle(parent.id);

  return (
    <>
      <TimelinePopupSampleRow sample={parent} />
      {visibleChildren.map((child) => (
        <TimelinePopupSampleRow key={child.id} sample={child} />
      ))}
      {hiddenCount > 0 && (
        <ToggleButton disableRipple onClick={handleToggle}>
          {isExpanded ? SHOW_LESS_LABEL : `${SHOW_MORE_LABEL} (${hiddenCount})`}
        </ToggleButton>
      )}
    </>
  );
}
